import { Box, CircularProgress, Typography } from "@mui/material";
import {
  useGetPractitionerInfoQuery,
  useGetUserInfoQuery,
  useUpdatePractitionerInfoMutation
} from '../services/api';
import { User } from '../types';
import { EditableField } from '../EditableField';

export function PractitionerProfile() {
  const { data: user } = useGetUserInfoQuery();
  if (user?.role !== 'practitioner')
    return null;

  return <PractitionerProfileInternal
    user={user}
  />;
}

const PractitionerProfileInternal = ({
  user
}: {
  user?: User
}) => {
  const { data: practitioner, isFetching, isLoading, refetch } = useGetPractitionerInfoQuery();
  const [updatePractitionerInfo, { isLoading: isLoadingUpdate }] = useUpdatePractitionerInfoMutation();

  return (
    <>
      <Typography
        fontSize={22}
      >Profile Information</Typography>
      {isLoading
        ? <CircularProgress />
        : <>
          <Box
            marginY={2}
          >
            <Typography
              fontWeight={500}
              lineHeight={1}
            >Name</Typography>
            <Typography
            >{practitioner?.fullName}</Typography>
          </Box>
          <Box
            marginY={2}
          >
            <Typography
              fontWeight={500}
              lineHeight={1}
            >Email</Typography>
            <Typography
            >{user?.email}</Typography>
          </Box>
          <Box
            marginY={2}
          >
            <Typography
              fontWeight={500}
              lineHeight={1}
            >Username</Typography>
            <Typography
            >{user?.username}</Typography>
          </Box>
          <EditableField
            isLoading={isLoadingUpdate || isLoading || isFetching}
            label='Phone'
            onSubmit={phone => {
              updatePractitionerInfo({
                phone,
              }).then(refetch)
            }}
            type='phone'
            value={practitioner?.phone || ''}
          />
          <Box
            marginY={2}
          >
            <Typography
              fontWeight={500}
              lineHeight={1}
            >Bio</Typography>
            <Typography
            >{practitioner?.bio}</Typography>
          </Box>
          <Box
            marginY={2}
          >
            <Typography
              fontWeight={500}
              lineHeight={1}
            >Credentials</Typography>
            <Typography
            >{practitioner?.credentials.join(' ')}</Typography>
          </Box>
          <Box
            marginY={2}
          >
            <Typography
              fontWeight={500}
              lineHeight={1}
            >Special Interests</Typography>
            <Typography
            >{practitioner?.interests.map(interest => (
              <Typography
              >{interest}</Typography>
            ))}</Typography>
          </Box>
        </>}
    </>);
}
